import React, { useState } from 'react';
import Header from '../layout/header';
import BannerImg from "../assets/images/admin-banner.webp";
import VideoDownloadRequest from './video-download-request';
import VideoUploadRequest from './video-upload-request';

function VideoList() {
  const [activeTab, setActiveTab] = useState('download');
  return (
    <div className='home-wrapper main-wrapper main-wrapper-cms video-request'>
      <Header />
      <div className=' banner-admin'>
        <div className='banner-admin-div'>
          <img className='img-fluid banner-admin-img' src={BannerImg} alt='Banner image' width={"100%"} height={500} />
        </div>
        <div className='search-wrapper'>
          <div className='container'>
            <div className='search-sub-wrap'>
              <div className="row w-100 justify-content-end">
                <div className='col-12 col-md-2 banner-title-admin'>
                  Video Requests
                </div>
                <div className='col-12 col-md-10 col-lg-10 search-section'>
                  <div className="video-request-tabs">
                    <div
                      className={`btn-tabs ${activeTab === 'download' ? 'active' : ''}`}
                      onClick={() => setActiveTab('download')}
                    >
                      Media Download Requests
                    </div>
                    <div
                      className={`btn-tabs ${activeTab === 'upload' ? 'active' : ''}`}
                      onClick={() => setActiveTab('upload')}
                    >
                      Media Upload Requests
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-4">
        {activeTab === 'download' && (
          <VideoDownloadRequest />
        )}
        {activeTab === 'upload' && (
          <VideoUploadRequest />
        )}
      </div>
    </div>
  );
}

export default VideoList;
